import type { SpotifyAuthStatus } from '@hitster/shared';
import { useT } from '../i18n.tsx';
import { logoutSpotify, startSpotifyLogin } from '../net/spotify-auth.ts';

/**
 * Warnung bei fehlenden Spotify-Berechtigungen.
 *
 * Muss ueberall auftauchen, wo Spotify-Aufrufe stattfinden -- nicht nur
 * auf der Startseite. Der Host laedt seine Playlist in der Lobby; wenn
 * die Warnung dort fehlt, sieht er nur einen unerklaerlichen
 * 403-Fehler und sucht an der falschen Stelle.
 */
export function ScopeWarning({
  status,
  onChanged,
}: {
  status: SpotifyAuthStatus | null;
  onChanged?: () => void;
}) {
  const t = useT();

  if (!status?.linked || status.missingScopes.length === 0) return null;

  return (
    <div className="alert alert--error">
      <div className="stack stack--tight" style={{ width: '100%' }}>
        <strong>{t('spotify.missingScopes')}</strong>
        <span className="text-sm">{t('spotify.missingScopesFix')}</span>

        <code className="text-xs" style={{ wordBreak: 'break-all' }}>
          {status.missingScopes.join(', ')}
        </code>

        <button
          type="button"
          className="btn btn--spotify"
          onClick={() => {
            // Erst die Session verwerfen, dann neu anmelden. Der
            // Zustimmungsdialog wird serverseitig ohnehin erzwungen.
            void logoutSpotify()
              .then(() => {
                onChanged?.();
                startSpotifyLogin(window.location.pathname);
              })
              .catch(() => startSpotifyLogin(window.location.pathname));
          }}
        >
          {t('spotify.reconnect')}
        </button>

        <a
          className="btn btn--ghost"
          href="https://www.spotify.com/account/apps/"
          target="_blank"
          rel="noreferrer"
        >
          {t('spotify.openAppSettings')}
        </a>
      </div>
    </div>
  );
}
